const loggerInstance = require('./index');

export default loggerInstance;
